<template>
    <account :params="params.form">
        <template #before>
            <a-select
                class="account__select-nav"
                label=""
                name="categories"
                :options="params.menu"
                display="title"
                value="url"
                hideSelected
                v-model="currentPage"
                dropdownClasses="account__select-nav-dropdown"
            >
                <template #item="item">
                    <div class="flex v-center account__select-nav-item">
                        <a :href="item.url">{{ item.title }}</a>
                    </div>
                </template>
            </a-select>
        </template>

        <a-tab v-for="(tab, i) in form.tabs" :key="i" :name="i">
            <form action="" method="" @submit="formSend($event)" v-if="tab?.fields">
                <div class="account__body-section">

                    <div class="form-group row">
                        <div class="col sm-12"
                             :class="['d'+field.greedLang, field.className]"
                             v-for="field in tab?.fields">
                            <a-input
                                v-if="field.type=='password'||field.type=='text'"
                                :type="field.type=='password'&&!field.focused?'text':field.type"
                                :data-block="field.name"
                                :label="field.title"
                                :placeholder="field.leftIcon?'':field.title"
                                :name="field.name+(field.type=='password'?field.value:'')"
                                @focus="field.focused=true;"
                                :autocomplete="'off'"
                                :staticLabel="field.title!=''"
                                v-model="field.value"
                                :error="field.error"
                                @click="setError(field,false)"
                                :class="field.leftIcon&&field.title?'fields-group':''"
                            >
                                <template #before v-if="field.leftIcon">
                                    <div class="icon dark">
                                        <img :src="field.leftIcon" width="25" height="25"
                                             style="filter: invert(1);object-fit: contain;">

                                    </div>
                                </template>
                            </a-input>
                            <div class="textareaEditorWrap" v-else-if="field.type=='textarea'">
                                <label class="label">{{field.title}}</label>
                                <ckeditor :editor="editor" v-model="field.value" :config="editorConfig"></ckeditor>
                            </div>

                            <a-checkbox
                                v-else-if="field.type=='checkbox'"
                                :name="field.name"
                                @click="setError(field,false)"
                                :disabled="field.disabled"
                                :data-block="field.name"
                                :label="field.title"
                                v-model="field.value"
                            />
                            <a-date-picker
                                v-else-if="field.type=='date'"
                                :useManualInput="true"
                                :label="field.title"
                                @click="setError(field,false)"
                                :data-block="field.name"
                                :placeholder="field.title"
                                :name="field.name"
                                :error="field.error"
                                staticLabel
                                v-model="field.value"
                            />
                            <a-input
                                v-else-if="field.type=='file'"
                                class="field-dnd"
                                @click="setError(field,false)"
                                :data-block="field.name"
                                :label="field.title"
                                :placeholder="field.placeholder"
                                :hint="field.hint"
                                :name="field.name"
                                staticLabel
                                :type="field.type"
                                v-model="field.value"
                                :error="field.error"
                            />
                            <div :data-block="field.name" v-else-if="field.type=='subtitle'"
                                 class="account__body-section">
                                <h3>{{ field.title }}</h3>
                            </div>
                            <div :data-block="field.name" class="fields-desc" v-else-if="field.type=='label'">
                                {{ field.value }}
                            </div>
                            <div :data-block="field.name" v-else-if="field.type=='select'">
                                <a-select v-if="field.name !== 'NPO[PROP][CITIES][]'"
                                    class="a-select-tags"
                                    :label="field.title"
                                    @click="setError(field,false)"
                                    @change="setError(field,false)"
                                    :name="field.name"
                                    :placeholder="field.multiple?`${field.title}: ${field.value.length} из ${field.options.length}`:(field.value?(field.options.find(element => element.id == field.value)?.name):(field.placeholder?field.placeholder:field.title))"
                                    staticLabel
                                    :options="field.options"
                                    display="name"
                                    value="id"
                                    :multiple="field.multiple"
                                    :error="field.error"
                                    v-model="field.value"
                                >
                                    <template #item="item">
                                        <div class="flex v-center">
                                            <a-checkbox :label="item.name" v-model="item.selected"/>
                                        </div>
                                    </template>
                                </a-select>
                                <a-select v-if="field.name == 'NPO[PROP][CITIES][]'"
                                        class="a-select-tags"
                                        :label="field.title"
                                        @click="setError(field,false)"
                                        @change="setError(field,false)"
                                        :name="field.name"
                                        :placeholder="field.value.name"
                                        staticLabel
                                        :options="field.options"
                                        display="name"
                                        value="id"
                                        :multiple="field.multiple"
                                        :error="field.error"
                                        v-model="field.value"
                                >
                                <template #item="item">
                                  <div class="flex v-center">
                                    <a-checkbox :label="item.name" v-model="item.selected"/>
                                  </div>
                                </template>
                              </a-select>

                                <div class="tags flex wrap" v-if="field.multiple&&field.value.length > 0">
                                    <a-chip removable v-for="(tag, i) in field.value" :key="i"
                                            @remove="removeCategory(i,field)">{{ tag.name }}
                                    </a-chip>
                                </div>
                            </div>
                            <div :data-block="field.name" class="stepper-companies" v-else-if="field.type=='carusel'">
                                <div class="stepper-companies__header flex between v-center">
                                    <div class="stepper-companies__title">{{ field.title }}</div>
                                    <div class="slider-cards__btns">
                                        <button class="swiper-button-prev" ref="btnPrev">
                                            <svg class="icon" width="26" height="20" viewBox="0 0 26 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                                <path
                                                    d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                                <path
                                                    d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                                <path
                                                    d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                            </svg>
                                        </button>
                                        <button class="swiper-button-next" ref="btnNext">
                                            <svg class="icon" width="26" height="20" viewBox="0 0 26 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                                                <path
                                                    d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                                                <path
                                                    d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                                                <path
                                                    d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="slider-cards__wrap">
                                    <swiper
                                        :navigation="{
                                prevEl: btnPrev,
                                nextEl: btnNext,
                            }"
                                        :modules="modules"
                                        v-bind="{
                                slidesPerView: 5,
                                breakpoints: {
                                    320: {
                                        slidesPerView: 2.2,
                                        spaceBetween: 20,
                                    },
                                    600: {
                                        slidesPerView: 3.2,
                                        spaceBetween: 20,
                                    },
                                    768: {
                                        slidesPerView: 5,
                                        spaceBetween: 8,
                                    },
                                },
                            }"
                                    >
                                        <swiper-slide v-for="(slide, i) in field.items" :key="i">
                                            <div class="slide-company">
                                                <div class="slide-company__inner">
                                                    <div class="slide-company__media">
                                                        <img :src="slide.img" :alt="slide.title">
                                                    </div>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                            <div :data-block="field.name" v-else-if="field.type=='moreSotsLink'">
                                <div class="form-group ">
                                    <ABtn class="form-btn btn-add" fill="transparent" type="button"
                                          @click="addSocialLink(field)">
                                        <template #before>
                                            <svg class="icon" width="20" height="20" viewBox="0 0 20 20"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <rect y="9" width="20" height="2"/>
                                                <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                            </svg>
                                        </template>
                                        <template #content>{{ field.messages.btnAdd }}</template>
                                    </ABtn>

                                    <div class="row nowrap" v-for="(social, i) in field.links" :key="i">
                                        <div class="col d5 sm-6" :class="'d'+linkField.greedLang"
                                             v-for="(linkField,k) in social">
                                            <a-input
                                                v-if="linkField.type=='text'||linkField.type=='textarea'"
                                                :label="linkField.title"
                                                staticLabel
                                                v-model="linkField.value"
                                                @click="setError(field,false)"
                                                :error="linkField.error"
                                            >
                                                <template #before v-if="k==0">
                                                    <ABtn type="button" class="social-link__remove" fill="flat"
                                                          style="color: #68737D;" @click="removeSocialLink(i,field)">
                                                        <template #content>
                                                            <svg width="20" height="20" viewBox="0 0 20 2" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <rect width="20" height="2" fill="#68737D"/>
                                                            </svg>
                                                        </template>
                                                    </ABtn>
                                                </template>
                                            </a-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :data-block="field.name" class="form__actions" v-else-if="field.type=='button'">
                                <a-btn :label="field.title" class="primary d12" :fill="field.fill" type="button"
                                       @click.prevent="buttonAction(field)"/>
                            </div>
                            <div :data-block="field.name" class="form__actions" v-else-if="field.type=='video'">
                                <a-video :src="field.params.src"
                                         :cover="field.params.cover"
                                         :can-edit="field.params.canEdit"
                                         :title="field.title"
                                         v-model="field.value"
                                />
                            </div>
                            <div :data-block="field.name" class="form__actions" v-else-if="field.type=='files'">
                                <user-files
                                    :items="field.files"
                                    :params="field.params"
                                    :name="field.name"
                                    v-model="form.files"
                                    @onDelete="deleteFormFiles($event, field)"
                                >
                                    <template #actions="{item}">
                        <span class="user-files__remove-btn"
                              @click="fieldAction($event, item, item.actionUrl)">
                          {{ params.translates?.actionAddText }}
                        </span>
                                    </template>
                                </user-files>
                            </div>
                            <TagListSection
                                v-else-if="field.type=='tags'"
                                :title="field.title"
                                :tags="field.values"
                                :messages="params.messages"
                                :options="field.options"
                                :field-name="field.name"
                            />
                            <div class="diapazon" v-else-if="field.type==='diapazon'">
                                <div class="field static-label filled">
                                    <div class="field-content">
                                        <div class="control-wrap" tabindex="-1">
                                            <label class="label">{{ field.title + (field.req ? '*' : '') }}</label>
                                            <div class="row">
                                                <div class="d6 col sm-12" :class="'d'+(field.fields.length/2)"
                                                     v-for="subField in field.fields">

                                                    <a-input
                                                        label=""
                                                        :placeholder="subField.title"
                                                        :name="subField.name"
                                                        :type="subField.type"
                                                        @keypress="subField.error=false;"
                                                        v-model="subField.value"
                                                        :error="subField.error"
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="employes" v-else-if="field.type==='subElements'">
                                <div class="employee-item" v-for="(employee, i) in field.employees" :key="i+timestamp">
                                    <div class="flex v-center between">
                                        <h3>{{ field.messages.sotrudnikText }}{{i + 1}}</h3>
                                        <ABtn fill="flat" :label="field.messages.btnDel" @click="removeEmployee(field,i)" color="#000" type="button" />
                                    </div>
                                    <div class="form-group row">
                                        <template v-for="(EmployField,k) in employee">
                                            <input type="hidden" :name="EmployField.name" :value="field.employees[i][k].value" v-if="EmployField.type=='hidden'"/>
                                            <div class="col sm-12" :class="'d'+EmployField.greedLang" v-else>
                                                <a-input
                                                    v-if="EmployField.type=='text'||EmployField.type=='textarea'"
                                                    :type="EmployField.type"
                                                    :label="EmployField.title"
                                                    :placeholder="EmployField.title"
                                                    :name="EmployField.name"
                                                    :data-block="EmployField.name"
                                                    :error="field.employees[i][k]?.error"
                                                    staticLabel
                                                    v-model="field.employees[i][k].value"
                                                />
                                                <a-select
                                                    v-if="EmployField.type=='select'"
                                                    :label="EmployField.title"
                                                    :placeholder="EmployField.title"
                                                    :name="EmployField.name"
                                                    staticLabel
                                                    :options="EmployField.options"
                                                    value="id"
                                                    :data-block="EmployField.name"
                                                    display="name"
                                                    v-model="field.employees[i][k].value"
                                                    :error="field.employees[i][k].error"
                                                    :validator="(val) => item.processed ? required(val) : true"
                                                />
                                                <a-input
                                                    v-if="EmployField.type=='file'"
                                                    class="field-dnd"
                                                    :label="EmployField.title"
                                                    :placeholder="EmployField.placeholder"
                                                    :hint="EmployField.hint"
                                                    :name="EmployField.name"
                                                    :data-block="EmployField.name"
                                                    staticLabel
                                                    :type="EmployField.type"
                                                    v-model="field.employees[i][k].value"
                                                    :error="field.employees[i][k].error"
                                                />
                                                <div class="fields-desc" v-if="EmployField.type=='label'">{{EmployField.value}}</div>

                                            </div>
                                        </template>

                                    </div>
                                </div>
                                <ABtn class="form-btn btn-add" v-if="field.employees.length<field.maxcount" fill="transparent" type="button" @click="addEmployees(field)">
                                    <template #before>
                                        <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <rect y="9" width="20" height="2"/>
                                            <rect x="9" y="20" width="20" height="2" transform="rotate(-90 9 20)"/>
                                        </svg>
                                    </template>
                                    <template #content>{{field.messages.btnAdd}}</template>
                                </ABtn>
                            </div>
                            <pre v-else>{{ field }}</pre>
                        </div>
                    </div>
                </div>
            </form>
            <div v-if="tab.text" v-html="tab.text"></div>
            <ReviewsListSection title="" v-if="tab?.reviews" :list-data="tab.reviews" :count="tab?.count"/>
            <Achievements v-if="tab?.achievements" :result="tab?.achievements" :messages="params.messages"/>
            <template>

                <!--

                    <div class="form-group row">
                        <div class="col d6 sm-12">
                            <a-input
                                label="Имя*"
                                placeholder="Напишите Ваше имя"
                                name="firstname"
                                staticLabel
                                v-model="form.fields.employees[i].firstname.value"
                                :error="form.fields.employees[i].firstname.error"
                                :validator="(val) => form.processed ? required(val) : true"
                            />
                        </div>
                        <div class="col d6 sm-12">
                            <a-input
                                label="Фамилия*"
                                placeholder="Напишите Вашу фамилию"
                                name="lastname"
                                staticLabel
                                v-model="form.fields.employees[i].lastname.value"
                                :error="form.fields.employees[i].lastname.error"
                                :validator="(val) => form.processed ? required(val) : true"
                            />
                        </div>
                    </div>
            -->
                <!--
                <div class="account__body-section">
                    <h3>Документы и файлы</h3>
                    <user-files :items="form.fields.files.value">
                        <template #actions="{index}">
                            <span class="user-files__remove-btn" @click="removeFile($event, index)">Удалить</span>
                        </template>
                    </user-files>
                </div>


                      -->
            </template>
        </a-tab>

        <template #aside>
            <account-card v-bind="params.cardInfo">
                <template #actions>
                    <a-btn :label="params.messages.addtask"
                           v-if="params.messages.addtask"
                           class="secondary"
                           :href="params.cardInfo.taskLink"/>
                </template>
            </account-card>
            <aside-nav :items="params.menu"/>
            <ProgressCard v-if="params.progress" :data="params.progress"/>
            <UserDescription
                v-if="params.user"
                :description="params.user.description"
                :social="params.user.social"
            />
            <IntroCard/>
        </template>


    </account>
</template>

<script>

import {ref, computed, provide} from 'vue'
import each from 'lodash/each'
import Account from './Account.vue'
import AccountCard from '../cards/AccountCard.vue'
import AsideNav from '../AsideNav.vue'
import Achievements from '../Achievements/Achievements.vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import {
    ATab,
    ABtn,
    ABadge,
    AField,
    AInput,
    ACheckbox,
    ASelect,
    AChip,
    ADatePicker,
    useAProgressBar,
    AVideo,
} from '../ui'
import UserFiles from '../cards/UserFiles.vue'
import {required, isEmail, isPhone, fileRules} from '../../libs/Validators'
import {getType} from '../ui/utils/helpers'
import {saveAccountNPO, send} from '../../services/api'
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import ProgressCard from "../cards/ProgressCard";
import UserDescription from "../cards/UserDescription";
import TagListSection from "./TagListSection";
import IntroCard from "../cards/IntroCard";
import ReviewsListSection from "~/components/sections/ReviewsListSection";
export default {
    name: 'AccountNKO',
    components: {
        IntroCard,
        TagListSection,
        UserDescription,
        ProgressCard,
        Account,
        AccountCard,
        AsideNav,
        Achievements,
        ATab,
        ABtn,
        ABadge,
        UserFiles,
        AField,
        AInput,
        ACheckbox,
        ASelect,
        AChip,
        ADatePicker,
        required,
        isEmail,
        isPhone,
        fileRules,
        Swiper,
        SwiperSlide,
        Navigation,
        ReviewsListSection,
        AVideo
    },
    props: ['params'],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'link',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    'insertTable'
                ],
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
                    ]
                }
                // The configuration of the editor.
            }
        };
    },
    setup: (props, ctx) => {
        const timestamp = ref(0);
        const btnNext = ref(null)
        const btnPrev = ref(null)
        const currentPage = ref(props.params.menu.filter(row => row.current)[0])
        const progress = useAProgressBar();
        const form = ref({
            processed: false,
            tabs: props.params.form.tabs,
            fields: {},
            files: {},
        })

        provide('translates', props.params?.messages || {})


        const addEmployees = (field) => {
            if(field.employees.length < field.maxcount) {
                field.employees.push(JSON.parse(JSON.stringify(field.fields)));
            }
        }
        const removeEmployee = (field,i) => {

            field.employees.splice(i, 1);
            timestamp.value = Date.now()
        }
        const removeCategory = (i, field) => {
            field.value.splice(i, 1);
        }

        const changeLogoInput = (e) => {
            //const file = e.target.files[0];
            //form.value.fields.company_logo.preview = URL.createObjectURL(file)
        }

        const addSocialLink = (field) => {
            const copyObject = JSON.parse(JSON.stringify(field.fields));
            field.links.push(copyObject);
        }
        const removeSocialLink = (i, field) => {
            field.links.splice(i, 1);
        }

        const addFormFiles = (formData) => {
            if (Object.keys(form.value.files).length > 0) {
                // add files to form data

                each(form.value.files, (fileField, key) => {
                    each(fileField, (arFiles, fieldName) => {
                        if (arFiles === null) {
                            // delete flag
                            formData.append(`${key + fieldName}`, null);
                        }
                        each(arFiles, (file, i) => {
                            formData.append(`${key + fieldName}[${i}]`, file);
                        })
                    })
                })
            }
        }

        const deleteFormFiles = (event, fieldName) => {
            fieldName.files[event.key].del = true;
            fieldName.files[event.key].value = "";
        }

        const buttonAction = (field) => {
            if (field.name === "save_cancel") {
                location.reload();
            }
            if (field.name === "save_btn") {
                let formData = new FormData();

                addFormFiles(formData)

                if (!validateFormAdd(formData)) {
                    formSend(formData);
                }
            }
        };
        const validateItem = (field) => {
            let result = true;
            if (field.req) {
                if (field.reqtype === "file") {
                    if (!field.value) {
                        result = false;
                    }
                } else if (Array.isArray(field.value)) {
                    if (field.value.length <= 0) {
                        result = false;
                    }
                } else if(field.value==undefined||field.value==null) {
                    result = false;
                } else if ((field.value+'')?.trim() === "" || !field.value) {
                    result = false;
                }
            }
            if (result) {
                if (Array.isArray(field.links)) {
                    let tmpRes = true;
                    for (let linkIndex in field.links) {
                        for (let linkValIndex in field.links[linkIndex]) {
                            if (!validateItem(field.links[linkIndex][linkValIndex])) {
                                tmpRes = false;
                            }
                        }
                    }
                } else if (field.reqtype !== undefined) {
                    if (field.rules) {
                        for (let ruleIndex in field.rules) {
                            switch (field.rules[ruleIndex].rule) {
                                case "minLength":
                                    if (field.value?.length < field.rules[ruleIndex].val && (field.req || field.value?.length > 0)) {
                                        showNotification("danger", field.title, field.rules[ruleIndex].invalidMessage);
                                        result = false;
                                    }
                                    break;
                                case "compare":
                                    let norm = false;
                                    for (let tabIndex in form.value.tabs) {
                                        if (form.value.tabs[tabIndex].fields !== undefined) {
                                            for (let fieldIndex in form.value.tabs[tabIndex].fields) {
                                                if (form.value.tabs[tabIndex].fields[fieldIndex].name === field.rules[ruleIndex].val) {
                                                    if (field.value === null) {
                                                        field.value = "";
                                                    }
                                                    if (form.value.tabs[tabIndex].fields[fieldIndex].value === null) {
                                                        form.value.tabs[tabIndex].fields[fieldIndex].value = "";
                                                    }
                                                    if (field.value == form.value.tabs[tabIndex].fields[fieldIndex].value) {
                                                        norm = true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if (!norm) {
                                        showNotification("danger", field.title, field.rules[ruleIndex].invalidMessage);
                                        result = false;
                                    }
                                    break;
                            }
                        }
                    } else {
                        switch (field.reqtype) {
                            case "email":
                                result = isEmail(field.value);
                                break;
                            case "phone":
                                result = isPhone(field.value);
                                break;
                        }
                    }
                }
            }
            if (field) {
                field.error = !result;
            }
            return result;
        }
        const validateFormAdd = (formData) => {
            let error = false;
            let firstError = false;
            for (let tabIndex in form.value.tabs) {
                if (form.value.tabs[tabIndex].fields !== undefined) {
                    for (let fieldIndex in form.value.tabs[tabIndex].fields) {
                        if (typeof form.value.tabs[tabIndex].fields[fieldIndex] === 'object') {
                            let f = form.value.tabs[tabIndex].fields[fieldIndex];
                            if(f.type=='subElements') {
                                if (Array.isArray(f.employees)) {
                                    for (let employeeIndex in f.employees) {
                                        if (typeof f.employees[employeeIndex] === 'object') {
                                            for (let employeeFieldIndex in f.employees[employeeIndex]) {
                                                if (typeof f.employees[employeeIndex][employeeFieldIndex] === 'object') {
                                                    if (validateItem(f.employees[employeeIndex][employeeFieldIndex])) {
                                                        formData.append(
                                                            f.employees[employeeIndex][employeeFieldIndex].name,
                                                            f.employees[employeeIndex][employeeFieldIndex].value
                                                        );
                                                    } else {
                                                        error = true;
                                                        if (!firstError) {
                                                            firstError = f.employees[employeeIndex][employeeFieldIndex];
                                                        }
                                                    }

                                                }
                                            }
                                        }
                                    }
                                }
                            } else if (validateItem(f)) {
                                if (Array.isArray(f.value)) {
                                    for (let valueIndex in f.value) {
                                        if (f.name, f.value[valueIndex].id !== undefined) {
                                            formData.append(f.name, f.value[valueIndex].id);
                                        }
                                    }
                                } else if (f.value !== undefined && f.name !== undefined) {
                                    if (f.type == "checkbox" && !f.value) {
                                        formData.append(f.name, 0);
                                    } else if (f.value != null) {
                                        formData.append(f.name, f.value);
                                    }
                                } else if (Array.isArray(f.fields) && !Array.isArray(f.links)) {
                                    for (let subFindex in f.fields) {
                                        if (f.fields[subFindex].name != undefined && f.fields[subFindex].name) {
                                            if (validateItem(f.fields[subFindex])) {
                                                formData.append(f.fields[subFindex].name, f.fields[subFindex].value);
                                            } else {
                                                error = true;
                                                if (!firstError) {
                                                    firstError = f;
                                                }
                                            }
                                        }

                                    }
                                } else if (Array.isArray(f.links)) {
                                    for (let linkIndex in f.links) {
                                        if (Array.isArray(f.links[linkIndex])) {
                                            for (let linkValIndex in f.links[linkIndex]) {
                                                if (Array.isArray(f.links[linkIndex][linkValIndex])) {
                                                    formData.append(f.links[linkIndex][linkValIndex].name, f.links[linkIndex][linkValIndex].value);
                                                }
                                            }
                                        }
                                    }
                                } else if (Array.isArray(f.files)) {
                                    for (let fileIndex in f.files) {
                                        if (f.files[fileIndex].del) {
                                            formData.append(f.files[fileIndex].inputDelName, "Y");
                                            formData.append(f.files[fileIndex].inputName + '_old_id', f.files[fileIndex].value_old);
                                        }
                                        if (form.value.files[f.files[fileIndex].inputName]) {
                                            formData.append(f.files[fileIndex].inputName, form.value.files[f.files[fileIndex].inputName][0]);
                                        }
                                    }
                                }
                            } else {
                                error = true;
                                if (!firstError) {
                                    firstError = f;
                                }
                            }
                        }
                    }
                }
            }
            if (firstError) {
                console.log(firstError);

                var destination = document.querySelector('[data-block="' + firstError.name + '"]');
                destination.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
            return error
        }
        const setError = (field, res) => {
            field.error = res;
        };

        const formSend = async (formData) => {
            progress.show();
            for (let hiddenFieldIndex in props.params.form.fields) {
                formData.append(props.params.form.fields[hiddenFieldIndex].name, props.params.form.fields[hiddenFieldIndex].value);
            }
            await send(props.params.form.action, {method: props.params.form.method}, formData).then((response) => {

                if (response["personal"]['information']) {
                    let notyByType = {};
                    for (let index in response["personal"]['information']) {
                        if (response["personal"]['information'][index].type !== undefined) {
                            if (notyByType[response["personal"]['information'][index].type] === undefined) {
                                notyByType[response["personal"]['information'][index].type] = [];
                            }
                            notyByType[response["personal"]['information'][index].type].push(response["personal"]['information'][index].text);
                        }
                    }
                    for (let type in notyByType) {
                        showNotification(type, '', notyByType[type].join('<br>'));
                    }
                }
                progress.hide();
            })


        }

        const feedback = () => {
            console.log('feedback')
        }

        const fieldAction = (event, file) => {
            console.log('fieldAction', {event, file});
            // switch (actionType) {
            //
            // }
        }

        return {
            form,
            addEmployees,
            setError,
            removeEmployee,
            removeCategory,
            changeLogoInput,
            addSocialLink,
            removeSocialLink,
            feedback,
            required,
            buttonAction,
            isEmail,
            isPhone,
            fileRules,
            btnNext,
            btnPrev,
            modules: [Navigation],
            formSend,
            currentPage,
            fieldAction,
            deleteFormFiles,
            timestamp,
        }
    },
}
</script>

<style lang="scss" scoped>
.employes {
    margin-bottom: 24px;
}
.diapazon > .field > .field-content:before {
    display: none;
}

.account__body-section {
    margin-top: 72px;

    .col:first-child {
        .account__body-section {
            margin-top: 0px;
        }
    }
}

::v-deep(.account-card) {
    .a-avatar__inner {
        width: auto !important;
        height: 130px !important;
        border-radius: 0;

        @include tablet {
            max-height: 80px;
        }
    }

    .account-card__bottom {
        @include tablet {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        @include mobile {
            display: block;
        }
    }
}

::v-deep(.account__body-section) {
    h3 {
        margin-bottom: 0;
    }
}

::v-deep(.account__header) {
    display: none !important;
}

.user-files {
    margin-top: 28px;
}

.user-files__remove-btn {
    font-size: 16px;
    color: var(--c-gray-500);
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
        color: var(--c-gray-400);
    }
}

.account__select-nav {
    display: none;
    @include tablet {
        display: flex;
    }
}

.aside-nav {
    @include tablet {
        display: none;
    }
}
</style>

<style lang="scss">
.diapazon > .field > .field-content {
    background: none;

    .field {
        margin-top: 0;

        .label {
            display: none;
        }
    }

}

.page__account {
    .tags {
        .a-chip__inner {
            background: #fff;
        }
    }
}

.account__additional-link .label {
    margin-left: 62px;
    @include mobile {
        margin-left: 44px;
    }
}

.account__select-nav-dropdown .a-item {
    padding: 0;

    a {
        color: var(--c-gray-100);
        width: 100%;
        display: flex;
        align-items: center;
        padding: 12px 16px;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>